{
  "home": "Tahanan",
  "calendar": "Kalendaryo",
  "map": "Mapa",
  "mine": "Aktibidad",
  "more": "Higit pa",
  "offices": "Mga opisina",
  "hotlines": "Mga hotline",
  "emergency": "Mag-ulat ng emergency",
  "cropDamage": "Mag-ulat ng pinsala sa pananim",
  "following": "Sinusundan",
  "notifications": "Mga abiso",
  "settings": "Mga setting",
  "privacy": "Privacy",
  "about": "Tungkol dito",
  "staffWorkspace": "Workspace ng kawani",
  "residentApp": "Tingin ng residente",
  "admin": "Administrasyon",
  "groupEssentials": "Mahahalaga",
  "groupSafety": "Kaligtasan at paghahanda",
  "groupAccount": "Account",
  "openMenu": "Buksan ang menu",
  "account": "Account",
  "myRequests": "Aking mga request",
  "groupServices": "Mga serbisyo",
  "services": "Mga serbisyo",
  "civilRegistry": "Civil Registry",
  "taxes": "Bayad at buwis",
  "reportConcern": "Mag-ulat ng problema",
  "charter": "Citizen's Charter",
  "feedback": "Puna at mungkahi",
  "search": "Maghanap",
  "groupCommunity": "Komunidad",
  "groupExplore": "Tuklasin",
  "guides": "Mga gabay sa bayan",
  "facilities": "Mag-book ng pasilidad",
  "proposals": "Mga panukala",
  "lostFound": "Nawala at natagpuan",
  "recycling": "Pagkuha ng recyclables",
  "marketPrices": "Presyo sa palengke",
  "tourism": "Turismo",
  "transparency": "Transparency",
  "documents": "Mga dokumento"
}
